'use client';

import { createContext, ReactNode } from 'react';

type ContextType = {
  authenticationEnabled?: boolean | null;
  themeBrandColor?: string | null;
};
export const AppConfigContext = createContext<ContextType | null>(null);

type Props = {
  authenticationEnabled?: boolean | null;
  themeBrandColor?: string | null;
} & { children: ReactNode };

export const AppConfigProvider = ({
  authenticationEnabled = true,
  children,
  themeBrandColor,
}: Props) => {
  return (
    <AppConfigContext.Provider
      value={{
        authenticationEnabled,
        themeBrandColor,
      }}
    >
      {children}
    </AppConfigContext.Provider>
  );
};
